//••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
const rgb = hex => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? { r: parseInt(result[1], 16), g: parseInt(result[2], 16), b: parseInt(result[3], 16) } : null;
};

//••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
const sets = [
  [rgb('#04264A'), rgb('#175389'), rgb('#337BB1'), rgb('#63AFD5'), rgb('#B0E5FB')],
  [rgb('#28044A'), rgb('#4D1789'), rgb('#6933B1'), rgb('#8963D5'), rgb('#C6B0FB')],
  [rgb('#4A0426'), rgb('#891753'), rgb('#B1337B'), rgb('#D563AF'), rgb('#FBB0E5')],
  [rgb('#4A2804'), rgb('#894D17'), rgb('#B16933'), rgb('#D58963'), rgb('#FBC6B0')],
  [rgb('#264A04'), rgb('#538917'), rgb('#7BB133'), rgb('#AFD563'), rgb('#E5FBB0')],
  [rgb('#044A28'), rgb('#17894D'), rgb('#33B169'), rgb('#63D589'), rgb('#B0FBC6')],
  [rgb('#05044A'), rgb('#171A89'), rgb('#333CB1'), rgb('#6376D5'), rgb('#B0C0FB')],
  [rgb('#4A0449'), rgb('#861789'), rgb('#A833B1'), rgb('#C263D5'), rgb('#EBB0FB')],
  [rgb('#4A0504'), rgb('#89171A'), rgb('#B1333C'), rgb('#D56376'), rgb('#FBB0C0')],
  [rgb('#494A04'), rgb('#898617'), rgb('#B1A833'), rgb('#D5C263'), rgb('#FBECB0')],
  [rgb('#044A05'), rgb('#1A8917'), rgb('#3CB133'), rgb('#76D563'), rgb('#C0FBB0')],
  [rgb('#04494A'), rgb('#178986'), rgb('#33B1A8'), rgb('#63D5C2'), rgb('#B0FBEC')],
];

//••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
export const getColor = (off, props) => {
  const set = sets[props.colorSet || 0];
  let r, g, b;

  switch (props.size) {
    case 3:
      return `rgb(${set[off].r}, ${set[off].g}, ${set[off].b})`;
    case 4:
      switch (off) {
        case 0:
          return `rgb(${set[0].r}, ${set[0].g}, ${set[0].b})`;
        case 1:
          r = set[0].r + ((set[1].r - set[0].r) * 2) / 3;
          g = set[0].g + ((set[1].g - set[0].g) * 2) / 3;
          b = set[0].b + ((set[1].b - set[0].b) * 2) / 3;
          return `rgb(${r}, ${g}, ${b})`;
        case 2:
          r = set[1].r + (set[2].r - set[1].r) / 3;
          g = set[1].g + (set[2].g - set[1].g) / 3;
          b = set[1].b + (set[2].b - set[1].b) / 3;
          return `rgb(${r}, ${g}, ${b})`;
        case 3:
          return `rgb(${set[2].r}, ${set[2].g}, ${set[2].b})`;
        case 4:
          r = set[2].r + ((set[3].r - set[2].r) * 2) / 3;
          g = set[2].g + ((set[3].g - set[2].g) * 2) / 3;
          b = set[2].b + ((set[3].b - set[2].b) * 2) / 3;
          return `rgb(${r}, ${g}, ${b})`;
        case 5:
          r = set[3].r + (set[4].r - set[3].r) / 3;
          g = set[3].g + (set[4].g - set[3].g) / 3;
          b = set[3].b + (set[4].b - set[3].b) / 3;
          return `rgb(${r}, ${g}, ${b})`;
        case 6:
        default:
          return `rgb(${set[4].r}, ${set[4].g}, ${set[4].b})`;
      }
    case 5:
      switch (off) {
        case 0:
          return `rgb(${set[0].r}, ${set[0].g}, ${set[0].b})`;
        case 1:
          r = (set[0].r + set[1].r) / 2;
          g = (set[0].g + set[1].g) / 2;
          b = (set[0].b + set[1].b) / 2;
          return `rgb(${r}, ${g}, ${b})`;
        case 2:
          return `rgb(${set[1].r}, ${set[1].g}, ${set[1].b})`;
        case 3:
          r = (set[1].r + set[2].r) / 2;
          g = (set[1].g + set[2].g) / 2;
          b = (set[1].b + set[2].b) / 2;
          return `rgb(${r}, ${g}, ${b})`;
        case 4:
          return `rgb(${set[2].r}, ${set[2].g}, ${set[2].b})`;
        case 5:
          r = (set[2].r + set[3].r) / 2;
          g = (set[2].g + set[3].g) / 2;
          b = (set[2].b + set[3].b) / 2;
          return `rgb(${r}, ${g}, ${b})`;
        case 6:
          return `rgb(${set[3].r}, ${set[3].g}, ${set[3].b})`;
        case 7:
          r = (set[3].r + set[4].r) / 2;
          g = (set[3].g + set[4].g) / 2;
          b = (set[3].b + set[4].b) / 2;
          return `rgb(${r}, ${g}, ${b})`;
        case 8:
        default:
          return `rgb(${set[4].r}, ${set[4].g}, ${set[4].b})`;
      }
    case 6:
      switch (off) {
        case 0:
          return `rgb(${set[0].r}, ${set[0].g}, ${set[0].b})`;
        case 1:
          r = set[0].r + ((set[1].r - set[0].r) * 2) / 5;
          g = set[0].g + ((set[1].g - set[0].g) * 2) / 5;
          b = set[0].b + ((set[1].b - set[0].b) * 2) / 5;
          return `rgb(${r}, ${g}, ${b})`;
        case 2:
          r = set[0].r + ((set[1].r - set[0].r) * 4) / 5;
          g = set[0].g + ((set[1].g - set[0].g) * 4) / 5;
          b = set[0].b + ((set[1].b - set[0].b) * 4) / 5;
          return `rgb(${r}, ${g}, ${b})`;
        case 3:
          r = set[1].r + ((set[2].r - set[1].r) * 2) / 5;
          g = set[1].g + ((set[2].g - set[1].g) * 2) / 5;
          b = set[1].b + ((set[2].b - set[1].b) * 2) / 5;
          return `rgb(${r}, ${g}, ${b})`;
        case 4:
          r = set[1].r + ((set[2].r - set[1].r) * 4) / 5;
          g = set[1].g + ((set[2].g - set[1].g) * 4) / 5;
          b = set[1].b + ((set[2].b - set[1].b) * 4) / 5;
          return `rgb(${r}, ${g}, ${b})`;
        case 5:
          return `rgb(${set[2].r}, ${set[2].g}, ${set[2].b})`;
        case 6:
          r = set[2].r + ((set[3].r - set[2].r) * 2) / 5;
          g = set[2].g + ((set[3].g - set[2].g) * 2) / 5;
          b = set[2].b + ((set[3].b - set[2].b) * 2) / 5;
          return `rgb(${r}, ${g}, ${b})`;
        case 7:
          r = set[2].r + ((set[3].r - set[2].r) * 4) / 5;
          g = set[2].g + ((set[3].g - set[2].g) * 4) / 5;
          b = set[2].b + ((set[3].b - set[2].b) * 4) / 5;
          return `rgb(${r}, ${g}, ${b})`;
        case 8:
          r = set[3].r + ((set[4].r - set[3].r) * 2) / 5;
          g = set[3].g + ((set[4].g - set[3].g) * 2) / 5;
          b = set[3].b + ((set[4].b - set[3].b) * 2) / 5;
          return `rgb(${r}, ${g}, ${b})`;
        case 9:
          r = set[3].r + ((set[4].r - set[3].r) * 4) / 5;
          g = set[3].g + ((set[4].g - set[3].g) * 4) / 5;
          b = set[3].b + ((set[4].b - set[3].b) * 4) / 5;
          return `rgb(${r}, ${g}, ${b})`;
        case 10:
        default:
          return `rgb(${set[4].r}, ${set[4].g}, ${set[4].b})`;
      }
    case 7:
      switch (off) {
        case 0:
          return `rgb(${set[0].r}, ${set[0].g}, ${set[0].b})`;
        case 1:
          r = set[0].r + (set[1].r - set[0].r) / 3;
          g = set[0].g + (set[1].g - set[0].g) / 3;
          b = set[0].b + (set[1].b - set[0].b) / 3;
          return `rgb(${r}, ${g}, ${b})`;
        case 2:
          r = set[0].r + ((set[1].r - set[0].r) * 2) / 3;
          g = set[0].g + ((set[1].g - set[0].g) * 2) / 3;
          b = set[0].b + ((set[1].b - set[0].b) * 2) / 3;
          return `rgb(${r}, ${g}, ${b})`;
        case 3:
          return `rgb(${set[1].r}, ${set[1].g}, ${set[1].b})`;
        case 4:
          r = set[1].r + (set[2].r - set[1].r) / 3;
          g = set[1].g + (set[2].g - set[1].g) / 3;
          b = set[1].b + (set[2].b - set[1].b) / 3;
          return `rgb(${r}, ${g}, ${b})`;
        case 5:
          r = set[1].r + ((set[2].r - set[1].r) * 2) / 3;
          g = set[1].g + ((set[2].g - set[1].g) * 2) / 3;
          b = set[1].b + ((set[2].b - set[1].b) * 2) / 3;
          return `rgb(${r}, ${g}, ${b})`;
        case 6:
          return `rgb(${set[2].r}, ${set[2].g}, ${set[2].b})`;
        case 7:
          r = set[2].r + (set[3].r - set[2].r) / 3;
          g = set[2].g + (set[3].g - set[2].g) / 3;
          b = set[2].b + (set[3].b - set[2].b) / 3;
          return `rgb(${r}, ${g}, ${b})`;
        case 8:
          r = set[2].r + ((set[3].r - set[2].r) * 2) / 3;
          g = set[2].g + ((set[3].g - set[2].g) * 2) / 3;
          b = set[2].b + ((set[3].b - set[2].b) * 2) / 3;
          return `rgb(${r}, ${g}, ${b})`;
        case 9:
          return `rgb(${set[3].r}, ${set[3].g}, ${set[3].b})`;
        case 10:
          r = set[3].r + (set[4].r - set[3].r) / 3;
          g = set[3].g + (set[4].g - set[3].g) / 3;
          b = set[3].b + (set[4].b - set[3].b) / 3;
          return `rgb(${r}, ${g}, ${b})`;
        case 11:
          r = set[3].r + ((set[4].r - set[3].r) * 2) / 3;
          g = set[3].g + ((set[4].g - set[3].g) * 2) / 3;
          b = set[3].b + ((set[4].b - set[3].b) * 2) / 3;
          return `rgb(${r}, ${g}, ${b})`;
        case 12:
        default:
          return `rgb(${set[4].r}, ${set[4].g}, ${set[4].b})`;
      }
    default:
      return 'rgb(0,0,0)';
  }
};

export const getStroke = color => {
  let rgb = color.slice(4).replace(')', '');
  rgb = rgb.split(',');

  return (rgb[0] * 1 + rgb[1] * 1.5 + rgb[2] * 1) / 3 < 150 ? 'white' : 'black';
};
